import actions from './signupActions'

export default {
  actions,
}
